import React from 'react';
import ReactDOM from 'react-dom/client';
import ProfileSpotlightSection from './components/ProfileSpotlightSection';
import CalendarSection from './components/CalendarSection';

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  // Mount the Profile Section with spotlight effect
  const profileContainer = document.getElementById('profile-spotlight-section-react');
  if (profileContainer) {
    const root = ReactDOM.createRoot(profileContainer);
    root.render(<ProfileSpotlightSection />);
  }

  // Mount the Calendar Section with spotlight effect
  const calendarContainer = document.getElementById('calendar-section-react');
  if (calendarContainer) {
    const root = ReactDOM.createRoot(calendarContainer);
    root.render(<CalendarSection />);
  }
});